/*
  Anomalie overhaul: small behaviours for the new sections.
  1. Any element with data-an-add="<variant id>" adds that item to the cart in place.
  2. A link with data-an-add-go="<variant id>" adds the design on the product page, then takes the
     shopper to the pack row on the same page (or follows the link when there is no pack row).
  3. The pack nudge in the cart (any element with data-an-nudge) is refreshed when the cart changes.
  4. The cart button in the top navigation (data-an-cart) opens the theme's cart drawer.
  5. On article pages, the shop block and shop rail are moved into the article text and sidebar.
  6. In the cart drawer, the pack nudge is marked so it can stay in view while the items scroll under it.
  7. After anything is added, the item count on the cart button is updated straight away and the button
     gives a short bump. An Add button then says how many of that design are in the cart ("2 in cart"),
     and tapping it again adds one more. Buttons for designs already in the cart say so when the page opens.
*/
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addItem(id) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  // fetches the pack nudge again and swaps it in wherever it is shown
  var nudgeTimer;
  function loadNudge() {
    var holders = document.querySelectorAll('[data-an-nudge]');
    if (!holders.length) return;
    fetch(root + 'cart?section_id=an-cart-nudge')
      .then(function (r) { if (!r.ok) throw new Error('nudge failed'); return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-an-nudge]');
        if (!fresh) return;
        holders.forEach(function (h) { h.innerHTML = fresh.innerHTML; });
      })
      .catch(function () {});
  }
  function refreshNudge() {
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(loadNudge, 200);
  }
  document.addEventListener('theme:cart:change', refreshNudge);

  // In the cart drawer the nudge's block gets the class an-stick, plus two measurements the styles need:
  // how far from the top it should stop (under the drawer's title when that stays put) and the colour behind it.
  function solidBackground(el) {
    while (el && el !== document.documentElement) {
      var c = window.getComputedStyle(el).backgroundColor;
      if (c && c !== 'transparent' && c !== 'rgba(0, 0, 0, 0)') return c;
      el = el.parentElement;
    }
    return '#fff';
  }
  function stickNudge() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var holder = drawer.querySelector('[data-an-nudge]');
    var block = holder && holder.closest('.cart-block');
    if (!block) return;
    var head = drawer.querySelector('.drawer__head');
    var top = 0;
    if (head && head !== block) {
      var pos = window.getComputedStyle(head).position;
      if (pos === 'sticky' || pos === 'fixed') top = head.offsetHeight;
    }
    block.classList.add('an-stick');
    block.style.setProperty('--an-stick-top', top + 'px');
    block.style.setProperty('--an-stick-bg', solidBackground(block.parentElement));
    if (!block.getAttribute('data-an-watched') && 'IntersectionObserver' in window) {
      block.setAttribute('data-an-watched', '1');
      new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) stickNudge();
      }).observe(block);
    }
  }
  document.addEventListener('theme:cart:change', stickNudge);

  // writes the number of items in the cart onto the cart button (and any other cart count on the page)
  function setCount(n) {
    document.querySelectorAll('cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-cart-count', n);
    });
    document.querySelectorAll('[data-an-cart]').forEach(function (c) {
      c.classList.remove('an-bump');
      void c.offsetWidth;
      c.classList.add('an-bump');
      c.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }
  function bumpStyle() {
    if (document.getElementById('an-bump-style')) return;
    var st = document.createElement('style');
    st.id = 'an-bump-style';
    st.textContent = '@keyframes an-bump{0%{transform:scale(1)}35%{transform:scale(1.12)}100%{transform:scale(1)}}' +
      '.an-bump{animation:an-bump .45s ease-out}.an-card__buy .an-btn{white-space:nowrap}' +
      '@media (prefers-reduced-motion: reduce){.an-bump{animation:none}}';
    document.head.appendChild(st);
  }
  // how many of one design (variant) are in the cart
  function qtyOf(cart, id) {
    var q = 0;
    (cart.items || []).forEach(function (i) { if (String(i.variant_id) === String(id)) q += i.quantity; });
    return q;
  }
  // labels an Add button with how many of its design are in the cart
  function labelAdd(b, q) {
    var name = b.getAttribute('data-an-name') || '';
    if (q > 0) {
      b.setAttribute('data-an-done', '1');
      b.textContent = q + ' in cart';
      b.setAttribute('aria-label', q + ' of ' + name + ' in your cart. Add one more');
    } else {
      b.removeAttribute('data-an-done');
      b.textContent = 'Add';
      b.setAttribute('aria-label', 'Add ' + name + ' to cart');
    }
  }
  // reads the cart, updates the count, and hands the cart on to whatever needs it
  function readCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { bumpStyle(); setCount(cart.item_count); return cart; })
      .catch(function () { return null; });
  }
  // on page load: buttons for designs already in the cart say how many
  function markInCart() {
    var buttons = document.querySelectorAll('[data-an-add]');
    if (!buttons.length) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        buttons.forEach(function (b) {
          if (!b.getAttribute('data-an-name')) b.setAttribute('data-an-name', (b.getAttribute('aria-label') || '').replace(/^Add /, '').replace(/ to cart$/, ''));
          var q = qtyOf(cart, b.getAttribute('data-an-add'));
          if (q > 0) labelAdd(b, q);
        });
      })
      .catch(function () {});
  }

  // asks the theme to refresh its cart drawer, and updates the count on the cart button
  function refreshCart() {
    try { document.dispatchEvent(new CustomEvent('theme:cart:refresh')); } catch (err) {}
    refreshNudge();
    return readCart();
  }

  function addInPlace(b) {
    if (b.disabled) return;
    if (!b.getAttribute('data-an-name')) b.setAttribute('data-an-name', (b.getAttribute('aria-label') || '').replace(/^Add /, '').replace(/ to cart$/, ''));
    var label = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding';
    addItem(b.getAttribute('data-an-add'))
      .then(function () {
        document.querySelectorAll('[data-an-bar-link]').forEach(function (a) {
          a.textContent = 'View cart';
          a.setAttribute('href', root + 'cart');
        });
        return refreshCart().then(function (cart) {
          b.disabled = false;
          var q = cart ? qtyOf(cart, b.getAttribute('data-an-add')) : 1;
          // every Add button for the same design gets the same count
          document.querySelectorAll('[data-an-add="' + b.getAttribute('data-an-add') + '"]').forEach(function (x) {
            if (!x.getAttribute('data-an-name')) x.setAttribute('data-an-name', b.getAttribute('data-an-name'));
            labelAdd(x, q || 1);
          });
        });
      })
      .catch(function () {
        b.disabled = false;
        b.textContent = label === 'Try again' ? 'Add' : 'Try again';
      });
  }

  function addAndGo(a) {
    if (a.getAttribute('data-an-busy')) return;
    var href = a.getAttribute('href');
    var row = document.getElementById('an-pack');
    var picked = document.querySelector('product-component input[name="id"]');
    var id = Number((picked && picked.value) || a.getAttribute('data-an-add-go'));
    a.setAttribute('data-an-busy', '1');

    function finish() {
      refreshCart();
      if (!row) { window.location.href = href; return; }
      a.removeAttribute('data-an-busy');
      a.removeAttribute('data-an-add-go');
      a.setAttribute('href', '#an-pack');
      a.textContent = a.getAttribute('data-an-done-text') || 'Added. Pick the rest below';
      row.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var has = (cart.items || []).some(function (i) { return i.variant_id === id || i.id === id; });
        return has ? null : addItem(id);
      })
      .then(finish)
      .catch(function () { window.location.href = href; });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('[data-an-add]');
    if (b) { e.preventDefault(); addInPlace(b); return; }
    var a = e.target.closest('[data-an-add-go]');
    if (a) { e.preventDefault(); addAndGo(a); return; }
    // the cart button in the top navigation opens the theme's cart drawer when there is one
    var c = e.target.closest('[data-an-cart]');
    if (c && window.theme && window.theme.hasCartDrawer) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('theme:cart:toggle', { bubbles: true }));
    }
  });

  function place() {
    var shop = document.querySelector('[data-an-inject="content"]');
    var content = document.querySelector('.article__content');
    if (shop && content && !shop.getAttribute('data-an-placed')) {
      var n = parseInt(shop.getAttribute('data-an-after'), 10) || 7;
      var ps = [];
      for (var i = 0; i < content.children.length; i++) {
        if (content.children[i].tagName === 'P') ps.push(content.children[i]);
      }
      // only move it into the text when the article is long enough; otherwise it stays below the article
      if (ps.length >= n + 4) ps[n - 1].insertAdjacentElement('afterend', shop);
      shop.setAttribute('data-an-placed', '1');
    }
    var rail = document.querySelector('[data-an-inject="rail"]');
    var side = document.querySelector('.sidebar__contents');
    if (rail && side && !rail.getAttribute('data-an-placed')) {
      side.insertBefore(rail, side.firstChild);
      rail.removeAttribute('hidden');
      rail.setAttribute('data-an-placed', '1');
    }
  }

  function start() { place(); stickNudge(); markInCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
